import React from "react";
import { Facebook } from "react-content-loader";

export const StatusTimelineLoader = () => {
  return (
    <div>
      <Facebook />
      <Facebook />
    </div>
  );
};
